import { useAuth } from "@/providers/AuthProvider";
import { getPageForRole } from "@/routes/routeMap";
import { useNavigate } from "react-router-dom";
import styles from "./AccessDenied.module.css";

const AccessDenied: React.FC = () => {
    const navigate = useNavigate();
    const { user } = useAuth();

    const handleBack = () => {
        navigate(getPageForRole(user?.role || null));
    };

    return (
        <div className={styles["access-denied"]}>
            <div className={styles["content"]}>
                <h1>Acceso Denegado</h1>
                <p>Lo sentimos, no tienes permisos para acceder a esta página.</p>
                <button onClick={handleBack} className={styles["back-button"]}>
                    Volver al inicio
                </button>
            </div>
        </div>
    );
};

export default AccessDenied;
